import { render, staticRenderFns } from "./ResetFeedback.vue?vue&type=template&id=4c8786c0&scoped=true&"
import script from "./ResetFeedback.vue?vue&type=script&lang=js&"
export * from "./ResetFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ResetFeedback.vue?vue&type=style&index=0&id=4c8786c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8786c0",
  null
  
)

export default component.exports